import { useState } from "react";
import { ChevronUp, ChevronDown, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { imgSrc } from "@/lib/api";

const ArrowBtn = ({ onClick, disabled, children, testId }) => (
  <button onClick={onClick} disabled={disabled} className="p-1 rounded hover:bg-blush disabled:opacity-20" data-testid={testId}>{children}</button>
);

export const PhotoRow = ({ p, cats, first, last, onMove, onUpdate, onDelete }) => {
  const [title, setTitle] = useState(p.title);
  return (
    <div className={`bg-white rounded-2xl border p-3 flex flex-col sm:flex-row sm:items-center gap-3 ${p.visible ? "" : "opacity-60"}`} data-testid={`admin-photo-${p.id}`}>
      <div className="flex items-center gap-3">
        <div className="flex sm:flex-col">
          <ArrowBtn onClick={() => onMove(-1)} disabled={first} testId={`photo-up-${p.id}`}><ChevronUp className="w-4 h-4" /></ArrowBtn>
          <ArrowBtn onClick={() => onMove(1)} disabled={last} testId={`photo-down-${p.id}`}><ChevronDown className="w-4 h-4" /></ArrowBtn>
        </div>
        <img src={imgSrc(p.src)} alt={p.title} className="w-24 h-20 rounded-xl object-cover shrink-0" />
      </div>
      <div className="flex-1 grid sm:grid-cols-2 gap-2">
        <Input value={title} onChange={(e) => setTitle(e.target.value)} onBlur={() => title.trim() && title !== p.title && onUpdate({ title: title.trim() })} data-testid={`photo-title-${p.id}`} />
        <Select value={p.category} onValueChange={(category) => onUpdate({ category })}>
          <SelectTrigger data-testid={`photo-category-${p.id}`}><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">{cats.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-4 text-sm justify-between sm:justify-start">
        <label className="flex items-center gap-2"><Switch checked={p.featured} onCheckedChange={(featured) => onUpdate({ featured })} data-testid={`photo-featured-${p.id}`} />En inicio</label>
        <label className="flex items-center gap-2"><Switch checked={p.visible} onCheckedChange={(visible) => onUpdate({ visible })} data-testid={`photo-visible-${p.id}`} />Visible</label>
        <AlertDialog>
          <AlertDialogTrigger className="p-2 rounded-lg text-ink/50 hover:text-destructive hover:bg-red-50" data-testid={`photo-delete-${p.id}`}><Trash2 className="w-4 h-4" /></AlertDialogTrigger>
          <AlertDialogContent className="bg-white">
            <AlertDialogHeader>
              <AlertDialogTitle>¿Eliminar esta foto?</AlertDialogTitle>
              <AlertDialogDescription>Dejará de aparecer en la web. Esta acción no se puede deshacer.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="photo-delete-cancel">Cancelar</AlertDialogCancel>
              <AlertDialogAction onClick={onDelete} className="bg-destructive hover:bg-destructive/90" data-testid="photo-delete-confirm">Eliminar</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
};
